export var PageEventName;
(function (PageEventName) {
    PageEventName["PAGE_CLEAR"] = "pageclear";
})(PageEventName || (PageEventName = {}));
//# sourceMappingURL=PageEnums.js.map